import { AttachmentFileType } from './types/AttachmentFile';
import { LazyImport, LazyModule, preloadScriptChunk } from 'owa-bundling';
preloadScriptChunk('AttachmentsCommon');
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "AttachmentsCommon" */ './lazyIndex');
});
export var lazyCreateLocalComputerFiles = new LazyImport(lazyModule, function (m) { return m.createLocalComputerFiles; });
export var lazyCreateMailItemFiles = new LazyImport(lazyModule, function (m) { return m.createMailItemFiles; });
export var lazyCreateUriFiles = new LazyImport(lazyModule, function (m) { return m.createUriFiles; });
export { AttachmentFileType };
//# sourceMappingURL=index.js.map